import axios from "../api";
// 获取门票基本信息
export const getTicket = (t_date="2019-9-16") =>
axios(
	ticket_url + '/api/ticket/auto_detail', {
		p: "ter",
		t_date,
		tp_id:3
	}
)

//查询接口
export const getTicketStatus= (torder_id) =>
    axios(
        ticket_url + "/api/my/ticketorder/order_status", {
				   p: "ter",
				  torder_id
        },
        "GET",
        true
	);
		// 下单接口
export const createdTicketOrder = (td_tp_id,pt_id,toi_username,toi_card_num,toi_cardtype_id,is_children,is_parent,td_tp_ids) =>
	axios(
		ticket_url + "/api/ticketorder/ticketorder_help",
		{
			p: "ter",
			is_parent,
			td_tp_id,
		  pt_id,
		  toi_username,
		  toi_cardtype_id,
			toi_card_num,
			is_children,
			contact_phone: "",
			td_tp_ids
		},
		'POST',
		true
	)
// 退票
export const refund = (titem_ids) =>
	axios(
		ticket_url + "/api/ticketorder/refund", {
			api_token: localStorage.api_token,
			p: "ter",
			titem_ids
		},
		"POST",
		 true	
	)
// 微信订单支付
export const payTicketOrder = (torder_id=0,payment_id=9) =>
	axios(
		ticket_url + '/api/ticketorder/pay',
		{
			p: "w",
			torder_id,
			payment_id,
		},
		"POST",
		true
	)
	//支付宝支付
	export const payTicketOrder2 = (torder_id=0,payment_id=9) =>
	axios(
		ticket_url + '/api/ticketorder/pay_help',
		{
			p: "w",
			torder_id,
			payment_id,
		},
		"POST",
		true
	)
	// 退票订单
export const OrderCancelTickert = (titem_ids) =>
	axios(ticket_url + "/api/ticketorder/refund",
		{
			p: "ter",
			titem_ids
		},
		"POST",
		true
	)
// 取消订单
export const cancelTickert = (torder_id) =>
axios(ticket_url + "/api/ticketorder/cancel",
		{
			p: "ter",
			
			torder_id
		},
		"GET",
		true
	)
// 售票订单
export const SellerTicketList = (page=1,limit=20,start_date,end_date,order_sn,contact_phone,payment_id) =>
	axios(
		ticket_url + '/api/seller/record',
		{
			p: "ter",
			page,
			limit,
			order_sn,
			contact_phone,
			start_date,
			end_date,
			payment_id,
			api_token:localStorage.api_token
		},
		"GET",
		true
	)
// 订单详情查看
export const TicketInfo = (torder_id) =>
	axios(
		ticket_url+'/api/my/ticketorder/detail',
		{
			p: "ter",
			
			torder_id
		},
		'GET'
	)
export const print_ticket = (titem_ids="") =>
	axios(
		ticket_url + "/api/seller/pickup",
		{
			p: "ter",
			titem_ids
		},
		"POST",
		true
	)
export const getTickets = (idcard,toi_sn="") =>
	axios(
		ticket_url + "/api/pickup_help",
		{
			p: "ter",
			idcard,
			toi_sn
		},
		"POST",
		true
	)
export const getLimit=()=>
	axios(
		ticket_url + "/api/ticket/text_tip",
		{
			p: "ter"
		},
		"GET",
		true
	)


// WEBPACK FOOTER //
// ./src/http/modules/ticket.js